import { Menu, MenuItem } from '@mui/material';
import React from 'react';


interface IProps {
  contentxMenu:any;
  onClose:() => void;
  onContextMenuAction: (info: any) => void;
}
const ContextMenu = ({ contextMenu, onClose, onContextMenuAction }) => {
  const eventId = contextMenu && contextMenu.eventId ?  contextMenu.eventId : null;
  return (
    <div>
      <Menu
       open={contextMenu !== null}
       onClose={onClose}
       anchorReference="anchorPosition"
       anchorPosition={
         contextMenu !== null
           ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
           : undefined
       }
      >
        {eventId && <MenuItem onClick={() => onContextMenuAction(contextMenu)}>Copy</MenuItem>}
        {!eventId && <MenuItem onClick={() => onContextMenuAction(contextMenu)}>Paste</MenuItem>}
        {!eventId && <MenuItem onClick={() => onContextMenuAction({...contextMenu, actionType:'clear'})}>Clear Selection</MenuItem>}
      </Menu>
    </div>
  );
};

export default ContextMenu;
